var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1392_12751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99947 1.54688C3.98856 1.54688 1.54492 3.99051 1.54492 7.00142C1.54492 10.0123 3.98856 12.456 6.99947 12.456C10.0104 12.456 12.454 10.0123 12.454 7.00142C12.454 3.99051 10.0104 1.54688 6.99947 1.54688ZM6.26211 9.37514C6.06685 9.5704 5.75027 9.5704 5.55501 9.37514L3.53484 7.35497C3.33958 7.15971 3.33958 6.84313 3.53484 6.64787L3.59732 6.58539C3.79239 6.39032 4.10859 6.3901 4.30393 6.5849L5.55501 7.83249C5.75035 8.02729 6.06655 8.02707 6.26162 7.832L9.69375 4.39986C9.8895 4.20411 10.2071 4.20467 10.4021 4.40111L10.4666 4.46605C10.6607 4.66151 10.6601 4.97713 10.4653 5.17191L6.26211 9.37514Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1392_12751"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.454102 5.45508C0.454102 2.69365 2.69268 0.455078 5.4541 0.455078H8.54501C11.3064 0.455078 13.545 2.69365 13.545 5.45508V8.54599C13.545 11.3074 11.3064 13.546 8.54501 13.546H5.4541C2.69268 13.546 0.454102 11.3074 0.454102 8.54599V5.45508Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.e00aa2812575212392a6d763b14525ed.svg";
export { ForwardRef as ReactComponent };